// import {
//   CriteriaWithPagination,
//   EuiBasicTable,
//   EuiBasicTableColumn,
//   EuiButtonIcon,
//   EuiComboBox,
//   EuiFlexGroup,
//   EuiFlexItem,
//   EuiFormRow,
//   EuiLink,
//   EuiSpacer,
//   EuiTableSelectionType,
//   Pagination,
//   euiPaletteColorBlindBehindText,
// } from "@elastic/eui";
// import { Divider, Menu, Text, Title } from "@mantine/core";
// import { modals } from "@mantine/modals";
// import { useEffect, useState } from "react";
// import { NotificationExtension } from "../../../_base/extension/NotificationExtension";
// import {
//   isNullOrEmpty,
//   isNullOrUndefined,
//   isNullOrUndefinedArry,
// } from "../../../_base/extension/StringExtension";
// import Repository from "../../../_base/helper/HttpHelper";
// import { useDisclosure } from "@mantine/hooks";
// import { paginationBase } from "../../../_base/model/_base/BaseTable";
// import { ParamSearchBase } from "../../../_base/model/_base/ParamSearchBase";
// import { getDataBannerLocation } from "../../../api/ApiBannerManager";
// import AppAction from "../../../common/AppAction";
// import AppSearch from "../../../common/AppSearch";
// import { API_ROUTE } from "../../../const/apiRoute";
// import { MessageResponse } from "../../../model/MessageResponse";
// import { tblBanner } from "../../../model/TblBanner";
// import CreateView from "./CreateView";
// import DeleteView from "./DeleteView";
// import EditView from "./EditView";
// import UpdateOrderNumberView from "./UpdateOrderNumberView";
// const visColorsBehindText = euiPaletteColorBlindBehindText();

// const BannerManager = () => {
//   const changeImageUrl = (url: string) => {
//     if (url.includes("192.168.3.96:9500")) {
//       return url.replace("192.168.3.96:9500", "image-dev.hacom.vn:9500");
//     }
//     return url;
//   };

//   const optionSearch = {
//     isActive: [
//       {
//         value: "A",
//         label: "Kích hoạt",
//         "data-test-subj": "titanOption",
//         color: visColorsBehindText[0],
//       },
//       {
//         value: "I",
//         label: "Chưa kích hoạt",
//         color: visColorsBehindText[1],
//       },
//     ],
//   };
//   const columns: Array<EuiBasicTableColumn<any>> = [
//     {
//       field: "id",
//       name: "ID",
//       sortable: true,
//       truncateText: true,
//       width: "5%",
//     },
//     {
//       field: "name",
//       name: "Tên banner",
//       sortable: true,
//       truncateText: true,
//       width: "20%",
//       render: (itemName: string) => (
//         <EuiLink
//           target="_blank"
//           onClick={(e: any) => {
//             const item = datas.find((x) => x.name === itemName);
//             if (item !== undefined && item.id > 0) handleEditData(item?.id);
//           }}
//         >
//           {itemName}
//         </EuiLink>
//       ),
//     },
//     {
//       field: "code",
//       name: "Mã banner1",
//       sortable: true,
//       truncateText: true,
//       width: "20%",
//     },
//     {
//       field: "fileBanner",
//       name: "Banner",
//       sortable: true,
//       truncateText: true,

//       render: (link: string) => (
//         <>
//           <img
//             src={changeImageUrl(link)}
//             alt=""
//             style={{ width: "25%", height: "20%" }}
//           />
//         </>
//       ),
//     },
//     {
//       field: "orderNumber",
//       name: "Thứ tự",
//       sortable: true,
//       truncateText: true,
//       width: "5%",
//       render: (ordering: number, brand: tblBanner) => (
//         <EuiLink
//           target="_blank"
//           onClick={() => modalChangeOrderBanner(ordering, brand)}
//         >
//           {ordering}
//         </EuiLink>
//       ),
//     },
//     {
//       field: "",
//       name: "Kích thước",
//       sortable: true,
//       truncateText: true,
//       width: "10%",
//       render: (item: tblBanner) => (
//         <>
//           <Text>
//             {item.bannerWidth || 0}px x {item.bannerHeight || 0}px
//           </Text>
//         </>
//       ),
//     },
//     {
//       name: "Actions",
//       width: "5%",
//       render: (online: any) => {
//         return (
//           <>
//             <EuiFlexGroup
//               responsive={true}
//               wrap={false}
//               gutterSize="s"
//               alignItems="center"
//             >
//               <EuiFlexItem grow={false}>
//                 <EuiButtonIcon
//                   iconType="documentEdit"
//                   aria-label="Dashboard"
//                   color="success"
//                   onClick={(e: any) => {
//                     if (isNullOrUndefined(online))
//                       NotificationExtension.Warn("Xin vui lòng chọn dữ liệu !");
//                     else {
//                       editItem(online.id);
//                     }
//                   }}
//                 />
//               </EuiFlexItem>
//               <EuiFlexItem grow={false}>
//                 <EuiButtonIcon
//                   iconType="trash"
//                   color="danger"
//                   onClick={(e: any) => {
//                     if (isNullOrUndefined(online))
//                       NotificationExtension.Warn("Xin vui lòng chọn dữ liệu !");
//                     else {
//                       deleteItem([online.id]);
//                     }
//                   }}
//                 />
//               </EuiFlexItem>
//             </EuiFlexGroup>
//           </>
//         );
//       },
//     },
//   ];

//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState<string | undefined>();
//   const [visible, { toggle, close, open }] = useDisclosure(false);
//   const [pagination, setPagination] = useState<Pagination>(paginationBase);
//   const [paramSearch, setParamSearch] = useState<ParamSearchBase>();
//   const [isSelectedItem, setSelectedItems] = useState<any[]>([]);
//   const [datas, setDatas] = useState<tblBanner[]>([]);
//   const [total, setTotal] = useState(0);
//   const [selectedActive, setSelectedActive] = useState<any[]>([]);
//   const [selectedFeature, setSelectedFeature] = useState<any[]>([]);
//   const [featureSearch, setFeatureSearch] = useState<any[]>([]);
//   const [dataBannerLocation, setDataBannerLocation] = useState<any[]>([]);
//   const handleEditData = async (id: number) => {
//     if (id) {
//       editItem(id);
//     } else {
//       NotificationExtension.Warn("Xin vui lòng chọn dữ liệu !");
//     }
//   };

//   const onTableChange = async ({
//     page: { index, size },
//   }: CriteriaWithPagination<any>) => {
//     setPagination({
//       ...pagination,
//       pageIndex: index,
//       pageSize: size,
//       totalItemCount: 1000,
//     });
//   };

//   const onChangeText = (event: React.ChangeEvent<HTMLInputElement>) => {
//     const key = event.target.value;
//     if (!isNullOrUndefined(key))
//       setParamSearch({ ...paramSearch, keyWord: key });
//   };

//   const onSelectionChange = (selectedItems: any[]) => {
//     setSelectedItems(selectedItems);
//   };
//   const selection: EuiTableSelectionType<any> = {
//     selectable: (user: any) => true,
//     selectableMessage: (selectable: boolean) =>
//       !selectable ? "User is currently offline" : "",
//     onSelectionChange,
//   };
//   const onChangeActive = (selectedOptions: any) => {
//     setSelectedActive(selectedOptions);
//     if (!isNullOrUndefinedArry(selectedOptions)) {
//       const value = selectedOptions[0].value;
//       if (!isNullOrUndefined(value))
//         setParamSearch({ ...paramSearch, inActive: value });
//     } else setParamSearch({ ...paramSearch, inActive: undefined });
//   };
//   const onChangeFeature = (selectedOption: any[]) => {
//     setSelectedFeature(selectedOption);
//     setFeatureSearch(selectedOption);
//   };
//   const loadDataBannerLocation = async () => {
//     setDataBannerLocation([]);
//     const data = await getDataBannerLocation("Active=true&Skip=0&Take=1000");
//     const transformedData = data?.data.map((item: any, index: number) => ({
//       value: item.id.toString(),
//       label: item.bannerLocName,
//       color: visColorsBehindText[index % visColorsBehindText.length],
//     }));
//     setDataBannerLocation(transformedData);
//   };
//   const openModal = () =>
//     modals.openConfirmModal({
//       title: (
//         <>
//           <div color="white">
//             <Title order={5}>Thêm mới Banner</Title>
//           </div>
//         </>
//       ),
//       children: (
//         <CreateView
//           onSearch={() =>
//             fetchDataBanner(
//               pagination.pageIndex,
//               pagination.pageSize,
//               paramSearch?.keyWord,
//               paramSearch?.inActive
//             )
//           }
//         />
//       ),
//       confirmProps: { display: "none" },
//       cancelProps: { display: "none" },
//     });

//   const openModalEdit = () => {
//     if (
//       isSelectedItem &&
//       (isSelectedItem.length < 1 || isSelectedItem.length > 1)
//     )
//       NotificationExtension.Warn(
//         "Xin vui lòng chọn 1 danh mục khách hàng để chỉnh sửa !"
//       );
//     else {
//       editItem(isSelectedItem[0].id);
//     }
//   };

//   const openModalDelete = () => {
//     if (isSelectedItem && isSelectedItem.length < 1)
//       NotificationExtension.Warn("Xin vui lòng chọn dữ liệu !");
//     else {
//       const ids = isSelectedItem;
//       deleteItem(ids.map((item) => item?.id));
//     }
//   };
//   const modalChangeOrderBanner = (orderNumber: number, banner: tblBanner) => {
//     modals.openConfirmModal({
//       title: (
//         <>
//           <div color="white">
//             <Title order={5}>Cập nhật thứ tự hiển thị banner</Title>
//           </div>
//         </>
//       ),
//       children: (
//         <UpdateOrderNumberView
//           orderNumber={orderNumber}
//           banner={banner}
//           onSearch={() =>
//             fetchDataBanner(
//               pagination.pageIndex,
//               pagination.pageSize,
//               paramSearch?.keyWord,
//               paramSearch?.inActive
//             )
//           }
//         />
//       ),
//       confirmProps: { display: "none" },
//       cancelProps: { display: "none" },
//     });
//   };
//   function deleteItem(idItem: number[]) {
//     modals.openConfirmModal({
//       title: (
//         <>
//           <Title order={5}>Xóa Banner</Title>
//         </>
//       ),
//       children: (
//         <DeleteView
//           onSearch={() =>
//             fetchDataBanner(
//               pagination.pageIndex,
//               pagination.pageSize,
//               paramSearch?.keyWord,
//               paramSearch?.inActive
//             )
//           }
//           idItem={idItem}
//         />
//       ),
//       confirmProps: { display: "none" },
//       cancelProps: { display: "none" },
//     });
//   }

//   function editItem(id: number) {
//     modals.openConfirmModal({
//       title: (
//         <>
//           <Title order={5}>Chỉnh sửa Banner!</Title>
//         </>
//       ),

//       children: (
//         <EditView
//           id={id}
//           onSearch={() =>
//             fetchDataBanner(
//               pagination.pageIndex,
//               pagination.pageSize,
//               paramSearch?.keyWord,
//               paramSearch?.inActive
//             )
//           }
//         />
//       ),
//       confirmProps: { display: "none" },
//       cancelProps: { display: "none" },
//     });
//   }
//   const elementSearch = [
//     <Menu.Item closeMenuOnClick={false}>
//       <EuiFormRow label="Trạng thái ">
//         <EuiComboBox
//           aria-label="Accessible screen reader label"
//           placeholder="Chọn trạng thái"
//           options={optionSearch.isActive}
//           selectedOptions={selectedActive}
//           onChange={onChangeActive}
//           fullWidth={true}
//           isDisabled={loading}
//           isCaseSensitive
//         />
//       </EuiFormRow>
//     </Menu.Item>,
//     <Menu.Item closeMenuOnClick={false}>
//       <EuiFormRow label="Vị trí banner: ">
//         <EuiComboBox
//           aria-label="Accessible screen reader label"
//           placeholder="Chọn vị trí"
//           options={dataBannerLocation}
//           selectedOptions={selectedFeature}
//           onChange={onChangeFeature}
//           fullWidth={true}
//           isDisabled={loading}
//           isCaseSensitive
//         />
//       </EuiFormRow>
//     </Menu.Item>,
//   ];
//   const fetchDataBanner = async (
//     index: number,
//     size?: number,
//     keyWord?: string,
//     inActive?: boolean
//   ) => {
//     setLoading(true);
//     setDatas([]);
//     setError(undefined);
//     const repository = new Repository(process.env.REACT_APP_Demo_APP_API_URL);
//     try {
//       let urlSearch = `${API_ROUTE.GET_LIST_BANNER}?Skip=${
//         index * (size ?? 0)
//       }&Take=${size}`;
//       if (!isNullOrEmpty(keyWord))
//         urlSearch = urlSearch + `&KeySearch=` + keyWord;
//       if (!isNullOrUndefined(inActive))
//         urlSearch = urlSearch + `&Status=` + inActive;
//       if (!isNullOrUndefined(featureSearch)) {
//         featureSearch?.forEach(
//           (feature) => (urlSearch += `&LocationIds=${feature.value}`)
//         );
//       }
//       let callapi = await repository.get<MessageResponse<tblBanner[]>>(
//         urlSearch
//       );
//       if (isNullOrUndefined(callapi) || isNullOrUndefinedArry(callapi?.data)) {
//         setTotal(0);
//       } else {
//         setDatas(callapi?.data ?? []);
//         setPagination({
//           ...pagination,
//           totalItemCount: callapi?.totalCount ?? 0,
//         });
//         setTotal(callapi?.totalCount ?? 0);
//       }
//       return callapi?.data;
//     } catch (error: any) {
//       setError("Có lỗi xảy ra khi tải dữ liệu !");
//       return null;
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     const fetchData = async () => {
//       await fetchDataBanner(
//         pagination.pageIndex,
//         pagination.pageSize,
//         paramSearch?.keyWord,
//         paramSearch?.inActive
//       );
//     };
//     fetchData();
//     loadDataBannerLocation();
//   }, [pagination.pageIndex, pagination.pageSize]);
//   return (
//     <>
//       <AppAction
//         openModal={openModal}
//         openModalDelete={openModalDelete}
//         openModalEdit={openModalEdit}
//       ></AppAction>
//       <Divider my="sm" />
//       <AppSearch
//         loading={loading}
//         onChange={onChangeFeature}
//         onChangeText={onChangeText}
//         onSearch={() =>
//           fetchDataBanner(
//             pagination.pageIndex,
//             pagination.pageSize,
//             paramSearch?.keyWord,
//             paramSearch?.inActive
//           )
//         }
//         elementSearch={elementSearch}
//       />
//       <EuiSpacer size="l" />
//       <EuiBasicTable
//         tableCaption="Demo of EuiDataGrid with selection"
//         items={datas ? datas : []}
//         itemId="id"
//         error={error}
//         loading={loading}
//         noItemsMessage={"Không có dữ liệu"}
//         selection={selection}
//         columns={columns}
//         pagination={pagination}
//         isSelectable={true}
//         hasActions={true}
//         responsive={true}
//         onChange={onTableChange}
//         compressed={true}
//       />
//     </>
//   );
// };

// export default BannerManager;
import {
  ActionIcon,
  Anchor,
  Badge,
  Box,
  Button,
  Grid,
  Group,
  Input,
  Select,
  Text,
  TextInput,
  Title,
  Tooltip,
} from "@mantine/core";
import { useForm } from "@mantine/form";
import { modals } from "@mantine/modals";
import {
  IconEdit,
  IconPlus,
  IconSearch,
  IconTimeDuration15,
  IconTrash,
} from "@tabler/icons-react";
import {
  MantineReactTable,
  MRT_ColumnDef,
  MRT_PaginationState,
  MRT_RowSelectionState,
  useMantineReactTable,
} from "mantine-react-table";
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import BreadCrumb from "../../../_base/component/_layout/_breadcrumb";
import { NotificationExtension } from "../../../_base/extension/NotificationExtension";
import Repository from "../../../_base/helper/HttpHelper";
import {
  getDataBannerLocation,
  modifyBannerOrder,
} from "../../../api/ApiBannerManager";
import { formatDateTransfer } from "../../../common/FormatDate/FormatDate";
import { _localization } from "../../../config/location";
import { API_ROUTE } from "../../../const/apiRoute";
import { tblBanner } from "../../../model/TblBanner";
import CreateView from "./CreateView";
import DeleteView from "./DeleteView";
import EditView from "./EditView";
import UpdateOrderNumberView from "./UpdateOrderNumberView";
interface SearchCriteria {
  keySearch?: string;
  status?: string;
  location?: string;
}

const BannerLocation = () => {
  const headerRef = React.useRef<HTMLDivElement>(null);
  const [isRefetching, setIsRefetching] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);
  const [pagination, setPagination] = useState<MRT_PaginationState>({
    pageIndex: 0,
    pageSize: 20,
  });
  type Search = string | number | boolean | object | null;
  const [dataBannerLocation, setDataBannerLocation] = useState<any[]>([]);
  const [height, setHeight] = useState(0);
  const [rowSelection, setRowSelection] = useState<MRT_RowSelectionState>({});
  const [data, setData] = useState<any[]>([]);
  const [rowCount, setRowCount] = useState(0);
  const [deleteViewStatus, setDeleteViewStatus] = useState(false);
  const [editViewProduct, setEditViewProduct] = useState(false);
  const [editingOrderId, setEditingOrderId] = useState<number | null>(null);
  const [editingOrderValue, setEditingOrderValue] = useState<string>("");
  const navigate = useNavigate();
  const location = useLocation();
  const _searchJson = sessionStorage.getItem(String(location.pathname))
    ? JSON.parse(sessionStorage.getItem(String(location.pathname)) ?? "")
    : null;
  const checkedPinSearch = localStorage.getItem("checkedPinSearch") == "true";
  const changeImageUrl = (url: string) => {
    if (url.startsWith("http://") || url.startsWith("https://")) {
      return url;
    }
    if (url.includes("192.168.3.96:9500")) {
      return url.replace("192.168.3.96:9500", "image-dev.hacom.vn");
    } else if (url.includes("192.168.2.17:9500")) {
      return url.replace("192.168.2.17:9500", "image-dev.hacom.vn");
    } else if (
      !url.includes("192.168.3.96:9500") &&
      !url.includes("192.168.2.17:9500") &&
      !url.includes("https://hanoicomputercdn.com") &&
      !url.includes("image-dev.hacom.vn")
    ) {
      return (url = "https://hanoicomputercdn.com" + url);
    }
    return url;
  };
  const loadDataBannerLocation = async () => {
    setDataBannerLocation([]);
    const data = await getDataBannerLocation("Active=true&Skip=0&Take=1000");
    const transformedData = data?.data.map((item: any, index: number) => ({
      value: item.id.toString(),
      label: item.id + "-" + item.bannerLocName,
    }));
    setDataBannerLocation(transformedData);
  };

  const optionSearch = {
    isActive: [
      {
        value: "A",
        label: "Kích hoạt",
        "data-test-subj": "titanOption",
        // color: visColorsBehindText[0],
      },
      {
        value: "I",
        label: "Chưa kích hoạt",
        // color: visColorsBehindText[1],
      },
    ],
  };
  const form = useForm<SearchCriteria>({
    mode: "uncontrolled",
    initialValues: {
      keySearch: _searchJson && checkedPinSearch ? _searchJson?.keySearch : "",
      status: _searchJson && checkedPinSearch ? _searchJson?.status : "",
      location: _searchJson && checkedPinSearch ? _searchJson?.location : "",
    },
  });

  const styleTableMantine = {
    fontWeight: "500",
  };

  const columns = React.useMemo<MRT_ColumnDef<any>[]>(
    () => [
      {
        accessorKey: "code",
        header: "Mã banner",
        Cell: ({ row }) => (
          <Badge color="green" variant="dot" radius="sm" size="lg" px="sm">
            <Text fw={500}>{row.original.code}</Text>
          </Badge>
        ),
        size: 200,
      },
      {
        accessorKey: "name",
        header: "Tên banner",
        size: 300,
      },
      {
        accessorKey: "fileBanner",
        header: "Banner",
        size: 200,
        Cell: ({ row }) => {
          const url = row.original.fileBanner;
          if (!url) return null;
          return (
            <img
              src={changeImageUrl(url)}
              alt="Ảnh Banner lỗi hiển thị"
              style={{ width: "80px", height: "60px", objectFit: "contain" }}
            />
          );
        },
      },
      {
        accessorKey: "bannerHeight",
        header: "Kích thước",
        size: 200,
        Cell: ({ row }) => (
          <Text
            fw={400}
          >{`${row.original.bannerWidth} x ${row.original.bannerHeight}`}</Text>
        ),
      },
      {
        accessorKey: "bannerUrlTarget",
        header: "Đường dẫn",
        enableSorting: false,
        enableColumnActions: false,
        enableColumnFilter: false,
        size: 200,
        Cell: ({ row }) => (
          <Group>
            <a
              href={`${row.original.bannerUrlTarget}`}
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: "#1c7ed6", textDecoration: "underline" }}
            >
              Xem trang banner
            </a>
          </Group>
        ),
      },
      {
        accessorKey: "orderNumber",
        header: "STT / Trạng thái",
        size: 200,
        Cell: ({ row }) => (
          <Box style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
            {editingOrderId === row.original.id ? (
              <Input
                type="number"
                size="xs"
                value={editingOrderValue}
                onChange={(e) => setEditingOrderValue(e.target.value)}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    handleUpdateOrderNumber(
                      row.original.id,
                      Number(editingOrderValue)
                    );
                  } else if (e.key === "Escape") {
                    setEditingOrderId(null);
                    setEditingOrderValue("");
                  }
                }}
                onBlur={() => {
                  if (
                    editingOrderValue &&
                    editingOrderValue !== String(row.original.orderNumber)
                  ) {
                    handleUpdateOrderNumber(
                      row.original.id,
                      Number(editingOrderValue)
                    );
                  } else {
                    setEditingOrderId(null);
                    setEditingOrderValue("");
                  }
                }}
                autoFocus
                style={{ width: "80px" }}
              />
            ) : (
              <Anchor
                onClick={() => {
                  setEditingOrderId(row.original.id);
                  setEditingOrderValue(String(row.original.orderNumber));
                }}
                c="blue"
                fw={500}
                underline="hover"
                style={{ cursor: "pointer" }}
              >
                STT: {row.original.orderNumber}
              </Anchor>
            )}
            <Badge
              color={row.original.status === "A" ? "green" : "red"}
              variant="light"
              size="md"
              radius="sm"
              style={{ cursor: "pointer" }}
              onClick={() => handleUpdateStatus(row.original.id)}
            >
              {row.original.status === "A" ? "Hiển thị" : "Không hiển thị"}
            </Badge>
          </Box>
        ),
      },
      {
        accessorKey: "fromDate",
        header: "Từ ngày",
        Cell: ({ renderedCellValue }: any) => (
          <Text size="sm">
            {renderedCellValue && formatDateTransfer(renderedCellValue)}
          </Text>
        ),
      },
      {
        accessorKey: "toDate",
        header: "Đến ngày",
        Cell: ({ renderedCellValue }: any) => (
          <Text size="sm">
            {renderedCellValue && formatDateTransfer(renderedCellValue)}
          </Text>
        ),
      },
      {
        accessorKey: "description",
        header: "Mô tả",
        size: 300,
      },
      {
        accessorKey: "action",
        header: "Thao tác ",
        enableSorting: false,
        enableColumnActions: false,
        enableColumnFilter: false,
        enableResizing: false,
        size: 135,
        Cell: ({ row }) => (
          <Box style={{ display: "flex", alignItems: "center", gap: "10px" }}>
            <Tooltip label="Chỉnh sửa">
              <ActionIcon
                variant="light"
                color="yellow"
                onClick={() => editItem(row.original.id)}
              >
                <IconEdit size={20} stroke={1.5} />
              </ActionIcon>
            </Tooltip>
            <Tooltip label="Xóa">
              <ActionIcon
                variant="light"
                color="red"
                onClick={async () => {
                  await deleteItem([row.original.id]);
                }}
              >
                <IconTrash size={20} stroke={1.5} />
              </ActionIcon>
            </Tooltip>
          </Box>
        ),
      },
    ],
    [editingOrderId, editingOrderValue]
  );

  // Hàm lấy dữ liệu
  const fetchData = async () => {
    setIsLoading(true);
    setIsRefetching(true);
    setIsError(false);
    const repository = new Repository(process.env.REACT_APP_Demo_APP_API_URL);

    try {
      const search = form.getValues();

      const queryParams = new URLSearchParams();

      if (search && search.keySearch) {
        queryParams.append("KeySearch", search.keySearch);
      }
      if (search && search.status) {
        queryParams.append("Status", search.status);
      }
      if (search && search.location) {
        queryParams.append("LocationIds", search.location);
      }

      if (pagination) {
        queryParams.append(
          "Skip",
          String(pagination.pageIndex * pagination.pageSize)
        );
        queryParams.append("Take", String(pagination.pageSize));
      }

      const url = `${API_ROUTE.GET_LIST_BANNER}?${queryParams.toString()}`;
      const response = await repository.get(url);
      if (response) {
        let result = response.data;
        setData(result);
        setRowCount(response.totalCount);
        table.resetRowSelection();
      }
    } catch (error) {
      setData([]);
      setIsError(true);
      console.error(error);
      return;
    } finally {
      setIsLoading(false);
      setIsRefetching(false);
      sessionStorage.setItem(
        String(location.pathname),
        JSON.stringify({
          ...form.getValues(),
          pageSize: pagination.pageSize,
          pageIndex: pagination.pageIndex,
        })
      );
    }
  };

  const handleUpdateOrderNumber = async (
    bannerId: number,
    newOrderNumber: number
  ) => {
    try {
      const orderNum = Number(newOrderNumber);
      if (orderNum < 0 || orderNum > 10000) {
        NotificationExtension.Fails(
          "STT chỉ được nằm trong khoảng 0 - 10000 !"
        );
        return;
      }

      await modifyBannerOrder({ id: bannerId, orderNumber: orderNum });
      NotificationExtension.Success("Cập nhật STT thành công!");
      setEditingOrderId(null);
      setEditingOrderValue("");
      await fetchData();
    } catch (error) {
      NotificationExtension.Fails("Cập nhật STT thất bại!");
      console.error(error);
    }
  };

  const modalChangeOrderBanner = (orderNumber: number, banner: tblBanner) => {
    modals.openConfirmModal({
      title: (
        <>
          <div color="white">
            <Title order={5}>Cập nhật thứ tự hiển thị banner</Title>
          </div>
        </>
      ),
      children: (
        <UpdateOrderNumberView
          orderNumber={orderNumber}
          banner={banner}
          onSearch={() => fetchData()}
        />
      ),
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
    });
  };

  const handleUpdateStatus = async (id: number) => {
    const repository = new Repository(process.env.REACT_APP_Demo_APP_API_URL);
    try {
      const response = await repository.post(
        `/TblBanner/update-status?id=${id}`,
        {}
      );

      if (response) {
        NotificationExtension.Success("Cập nhật trạng thái thành công!");
        await fetchData();
      }
    } catch (error) {
      NotificationExtension.Fails("Cập nhật trạng thái thất bại!");
      console.error(error);
    }
  };

  const openModal = () =>
    modals.openConfirmModal({
      title: (
        <>
          <div color="white">
            <Title order={5}>Thêm mới vị trí banner</Title>
          </div>
        </>
      ),
      children: <CreateView onSearch={() => fetchData()} />,
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
      closeOnClickOutside: false,
      closeOnEscape: false,
      withCloseButton: false,
    });
  function deleteItem(idItem: number[]) {
    modals.openConfirmModal({
      title: (
        <>
          <Title order={5}>Xóa vị trí banner</Title>
        </>
      ),
      children: <DeleteView onSearch={() => fetchData()} idItem={idItem} />,
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
    });
  }

  function editItem(id: number) {
    modals.openConfirmModal({
      title: (
        <>
          <Title order={5}>Chỉnh sửa banner!</Title>
        </>
      ),
      size: "auto",
      children: <EditView id={id} onSearch={() => fetchData()} />,
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
      closeOnClickOutside: false,
      closeOnEscape: false,
      withCloseButton: false,
    });
  }

  const table = useMantineReactTable({
    columns,
    data,
    enableColumnResizing: true,
    rowCount,
    enableColumnFilters: true,
    enableSorting: true,
    enableColumnActions: true,
    // manualPagination: true,

    state: {
      // columnFilters,
      // globalFilter,
      isLoading,
      pagination,
      showAlertBanner: isError,
      showProgressBars: isRefetching,
      showSkeletons: isLoading,
      rowSelection,
    },
    enableStickyFooter: true,
    manualFiltering: false,
    manualPagination: true,
    manualSorting: false,
    onPaginationChange: setPagination,
    positionToolbarAlertBanner: "bottom",
    initialState: {
      showColumnFilters: false,
      columnPinning: {
        left: ["mrt-row-select"],
        right: ["action"],
      },
      columnVisibility: { id: false },
      density: "xs",
    },
    mantineTopToolbarProps: {
      style: {
        display: "none",
      },
    },
    localization: _localization,
    getRowId: (row) => row.invoiceId,
    mantineTableContainerProps: {
      style: { maxHeight: height, minHeight: height },
    },
    enableStickyHeader: true,
    enableRowSelection: true,
    onRowSelectionChange: setRowSelection,
    mantineTableBodyCellProps: ({ row }) => ({
      style: styleTableMantine,
    }),
    mantineToolbarAlertBannerProps: false
      ? { color: "red", children: "Lỗi tải dữ liệu !" }
      : undefined,

    mantinePaginationProps: {
      showRowsPerPage: true,
      withEdges: true,
      radius: "xl",
      size: "lg",
      rowsPerPageOptions: ["20", "50", "100"],
      siblings: 1,
      boundaries: 1,
    },
    paginationDisplayMode: "pages",
    enableColumnPinning: true,
    mantineTableProps: {
      striped: false,
    },
    // mantineTableBodyRowProps: ({ row }) => ({
    //   onClick: row.getToggleSelectedHandler(),
    //   sx: { cursor: "pointer" },
    // }),
  });
  useEffect(() => {
    const headerHeight = headerRef.current?.offsetHeight || 0;
    const handleResize = () => {
      setHeight(window.innerHeight - (185 + headerHeight));
    };

    handleResize(); // Set initial height
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [height]);

  useEffect(() => {
    if (_searchJson) {
      setPagination({
        pageIndex: _searchJson.pageIndex,
        pageSize: _searchJson.pageSize,
      });
    }
  }, []);

  useEffect(() => {
    fetchData();
  }, [pagination.pageIndex, pagination.pageSize]);

  useEffect(() => {
    if (deleteViewStatus || editViewProduct) {
      fetchData();
    }
  }, [deleteViewStatus, editViewProduct]);

  useEffect(() => {
    loadDataBannerLocation();
  }, []);
  return (
    <Box>
      <Group gap={0} justify="space-between" mb={10}>
        <BreadCrumb></BreadCrumb>
      </Group>
      <div
        style={{ border: "1px solid #dee2e6", padding: "10px" }}
        ref={headerRef}
      >
        {/* Thông báo thời gian đồng bộ dữ liệu lên web */}
        <Box
          style={{
            background: "#fffbe6",
            border: "1.5px solid #ffe58f",
            borderRadius: 8,
            padding: "5px",
            marginBottom: 2,
            display: "flex",
            alignItems: "center",
            gap: 10,
            fontWeight: 600,
            color: "#ad6800",
            fontSize: 14,
          }}
        >
          <IconTimeDuration15
            size={22}
            color="#faad14"
            style={{ marginRight: 6 }}
          />
          <span>
            <b>Lưu ý:</b> Sau khi cập nhật,có thể dữ liệu sẽ được đồng bộ lên
            website trong khoảng <b>15-30 phút</b>. Vui lòng kiểm tra lại sau
            thời gian này để thấy thay đổi.
          </span>
        </Box>
        <Box style={{ display: "flex", justifyContent: "space-between" }}>
          <Grid mt={10}>
            <Grid.Col
              style={{ display: "flex", gap: "10px", flexWrap: "wrap" }}
            >
              <Input
                placeholder="Nhập tìm kiếm"
                key={form.key("keySearch")}
                type="text"
                leftSection={<IconSearch size={"20"} color="#15aabf" />}
                onKeyDown={async (e) => {
                  if (e.key === "Enter") {
                    await fetchData();
                  }
                }}
                {...form.getInputProps("keySearch")}
              />
              <Select
                placeholder="Chọn trạng thái"
                data={optionSearch.isActive}
                key={form.key("status")}
                clearable
                searchable
                {...form.getInputProps("status")}
                classNames={{
                  dropdown: "custom-multiselect-dropdown",
                }}
                maxDropdownHeight={500}
              />
              <Select
                placeholder="Chọn vị trí banner"
                data={dataBannerLocation}
                key={form.key("location")}
                clearable
                searchable
                {...form.getInputProps("location")}
                classNames={{
                  dropdown: "custom-multiselect-dropdown",
                }}
                maxDropdownHeight={500}
              />

              <Button
                color="blue"
                variant="outline"
                onClick={async () => {
                  await fetchData();
                }}
              >
                Tìm kiếm
              </Button>
            </Grid.Col>
          </Grid>
          <Group>
            <Button
              mt={10}
              leftSection={<IconPlus size={14} />}
              color="blue"
              variant="outline"
              onClick={async () => {
                openModal();
              }}
            >
              Thêm mới
            </Button>
            <Button
              mt={10}
              mr={10}
              leftSection={<IconTrash size={14} />}
              color="red"
              variant="outline"
              onClick={async () => {
                const selectedIds = Object.keys(rowSelection).map(
                  (key) => data[Number(key)].id
                );
                if (selectedIds && selectedIds.length < 1) {
                  NotificationExtension.Warn("Xin vui lòng chọn dữ liệu !");
                  return null;
                }
                await deleteItem(selectedIds);
              }}
            >
              Xóa (Đã chọn)
            </Button>
          </Group>
        </Box>
      </div>
      <Box mt={10}>
        <MantineReactTable table={table} />
      </Box>
    </Box>
  );
};

export default BannerLocation;
